import { CUSTOM_LAB_PATTERNS } from "@/config.ts";
import { cn } from "@/lib/utils";
import { Pattern } from "@/types/color-elements.ts";
import { Checkbox } from "@components/ui/checkbox.tsx";
import { ToggleGroup, ToggleGroupItem } from "@components/ui/toggle-group.tsx";
import { Check } from "lucide-react";
import React from "react";

type ColorLayerConfigPatternSelectProps = Omit<
  React.ComponentPropsWithoutRef<"div">,
  "onChange"
> & {
  value: Pattern[];
  onChange: (value: Pattern[]) => void;
};
export default function ColorLayerConfigPatternSelect({
  className,
  value,
  onChange,
  ...props
}: ColorLayerConfigPatternSelectProps) {
  function handleChange(values: string[]) {
    onChange(CUSTOM_LAB_PATTERNS.filter((p) => values.includes(p.url)));
  }

  return (
    <div className={cn(className)} {...props}>
      <label className="mb-2 flex cursor-pointer items-center gap-1 underline-offset-2 hover:underline">
        <Checkbox
          checked={value?.length === CUSTOM_LAB_PATTERNS.length}
          onCheckedChange={(checked) =>
            handleChange(checked ? CUSTOM_LAB_PATTERNS.map((p) => p.url) : [])
          }
        />{" "}
        Tout sélectionner
      </label>

      <ToggleGroup
        className={cn("grid w-fit grid-cols-4 gap-2")}
        type="multiple"
        value={value?.map((p) => p.url) || []}
        onValueChange={handleChange}
      >
        {CUSTOM_LAB_PATTERNS.sort((a, b) => a.name.localeCompare(b.name)).map(
          (pattern) => (
            <ToggleGroupItem
              key={pattern.name}
              className="group relative h-[64px] w-[64px] p-0"
              value={pattern.url}
            >
              <div
                className={cn(
                  "h-full w-full overflow-hidden rounded border bg-white",
                  "group-radix-state-on:border-2 group-radix-state-on:border-primary",
                  "duration-200 hover:scale-110",
                )}
                style={{
                  backgroundSize: `${pattern.thumbnailSize * 2}%`,
                  backgroundImage: `url(${pattern.url})`,
                }}
              >
                <div
                  className={cn(
                    "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                    "opacity-0 group-radix-state-on:opacity-100",
                  )}
                >
                  <Check className="stroke-primary" />
                </div>
              </div>
            </ToggleGroupItem>
          ),
        )}
      </ToggleGroup>
    </div>
  );
}
